import React, { useState, useEffect } from "react";
import { Typography, Grid2 } from "@mui/material";
import Divider from "@mui/material/Divider";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import MUILoader from "../../../components/MUILoader/MUILoader";
import MUITableSearch from "../../../components/MUITable/MUITableSearch";
// components
import CreateNewOrUpdateAccountModal from "./components/CreateNewOrUpdateAccountModal";
import AccountMasterDataTable from "./components/AccountMasterDataTable";
import DeleteAccountModal from "./components/DeleteAccountModal";
import { AccountMasterDataTableColumns } from "./components/AccountMasterDataTable.config"
import { handleOutSideDataTableSearch } from "../../../common/MuiTableFunctions.config";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import { APP_MESSAGE, ERROR_MESSAGE, SNACKBAR_VARIANT } from "../../../config/Messages.config";
import { getAllCompaniesInfo, deleteExistingCompanyAccount } from "../../../helpers/api-functions-helper";
import { getPageTitle } from "../../../common/CommonFunctions";
// import AccountMasterDataTable_V2 from "./components/zingworks/AccountMasterDataTable_V2";

const AccountMaster = () => {
  const { showSnackbar } = useSnackbar();
  const documentTitle = getPageTitle() && getPageTitle();
  document.title = documentTitle ? `${documentTitle} | Zing Auditor` : "Zing Auditor"
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [toggleCreateOrUpdateModal, setToggleCreateOrUpdateModal] =
    useState(false);
  const [toggleDeleteAccountModal, setToggleDeleteAccountModal] =
    useState(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const [modalDataState, setModalDataState] = useState({
    mode: "",
    data: null,
  });
  // search functionality
  const [searchText, setSearchText] = useState("");

  // Function used toggle modal on their types
  const handleToggleModal = (modalType) => {
    if (modalType === "Create/Update") {
      setToggleCreateOrUpdateModal((e) => !e);
    } else {
      setToggleDeleteAccountModal((e) => !e);
    }
  };

  // Function used handle data table actions
  const getRowDataOnClickOfAction = (ActionName, Data) => {
    if (ActionName === "Update Account") {
      setModalDataState((prev) => ({
        ...prev,
        mode: "Update",
        data: Data,
      }));
      handleToggleModal("Create/Update");
    } else if (ActionName === "View Account") {
      setModalDataState((prev) => ({
        ...prev,
        mode: "View",
        data: Data,
      }));
      handleToggleModal("Create/Update");
    } else if (ActionName === "Create Account") {
      handleToggleModal("Create/Update");
    } else {
      setModalDataState((prev) => ({
        ...prev,
        mode: "Delete",
        data: Data,
      }));
      handleToggleModal("Delete Account");
    }
  };

  // Fetch all plants
  const fetchAllCompaniesInfo = () => {
    setIsPageLoading(true);
    getAllCompaniesInfo()
      .then((response) => {
        if (response && response.data) {
          const { success, statusCode, data, message } = response.data;
          if (success && statusCode === 200) {
            setTableDataInstance(data);
            setTableData(data);
          } else {
            showSnackbar(
              message || data || APP_MESSAGE.ACCOUNT_MASTER.FETCHED.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.ACCOUNT_MASTER.FETCHED.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsPageLoading(false);
      });
  };

  const deleteExistingAccount = () => {
    setIsDeleteClicked(true);
    deleteExistingCompanyAccount(modalDataState.data?.id)
      .then((res) => {
        if (res && res.data) {
          // console.log(res.data);
          const { statusCode, success, data, message } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.ACCOUNT_MASTER.DELETE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.ACCOUNT_MASTER.DELETE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleToggleModal("Delete Account");
            setModalDataState({
              data: null,
              mode: "",
            });
            fetchAllCompaniesInfo();
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.PLANT_MASTER.DELETE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsDeleteClicked(false);
      });
  };

  // To fetch the data of Account Master
  useEffect(() => {
    if (navigator.onLine) {
      fetchAllCompaniesInfo();
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      setTableData(tableDataInstance);
    } else {
      const filteredData_ = handleOutSideDataTableSearch(
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <React.Fragment>
      {toggleCreateOrUpdateModal ? (
        <CreateNewOrUpdateAccountModal
          Open={toggleCreateOrUpdateModal}
          Title={
            modalDataState.data !== null
              ? "View Account Details"
              : "Create New Account"
          }
          DialogData={modalDataState.data}
          DialogType={modalDataState.mode}
          SetDialogData={setModalDataState}
          ToggleDialogBox={handleToggleModal}
          FetchAllCompaniesInfo={fetchAllCompaniesInfo}
          AllCompanyName={
            tableDataInstance[0] &&
            tableDataInstance.map((account) => account.name.toLowerCase())
          }
        />
      ) : null}
      {toggleDeleteAccountModal ? (
        <DeleteAccountModal
          ModalState={toggleDeleteAccountModal}
          SetDialogData={setModalDataState}
          ToggleFunction={handleToggleModal}
          LoaderState={isDeleteClicked}
          OnSubmit={deleteExistingAccount}
        />
      ) : null}
      <div className="page-content">
        {isPageLoading ? (
          <MUILoader />
        ) : (
          <div>
            <Grid2
              container
              className="d-flex align-items-center my-1"
              spacing={2}
            >
              <Grid2 size={{ xs: 12, sm: 9, md: 10, lg: 10 }} className="py-1">
                <Typography className="inter-medium-500">
                  {documentTitle}
                </Typography>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 3, md: 2, lg: 2 }} className="py-1">
                <AppButton OnPress={() => handleToggleModal("Create/Update")}>
                  Create New Account
                </AppButton>
              </Grid2>
            </Grid2>

            <Divider
              style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
              className="mt-2"
            />

            <Grid2 container className="my-2" spacing={2}>
              <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <MUITableSearch
                  CancelSearch={() => {
                    setSearchText("");
                  }}
                  HandleSearch={(e) => setSearchText(e.target.value)}
                  SearchText={searchText}
                />
              </Grid2>
            </Grid2>

            <Grid2 container className="my-2">
              <Grid2 size={{ xs: 12 }}>
                <AccountMasterDataTable
                  Columns={AccountMasterDataTableColumns}
                  RowData={tableData || []}
                  DenseTable={true}
                  IsOutSideSearch={true}
                  RowsToDisplay={10}
                  GetRowDataOnClickOfEditIcon={(actionName, data) => {
                    getRowDataOnClickOfAction(actionName, data);
                  }}
                  OptionsForRowsPerPage={[5, 10, 15, 25, 50]}
                />
                {/* <AccountMasterDataTable_V2 
                  Rows={tableData || []}
                  GetRowDataOnClickOfAction={getRowDataOnClickOfAction}
                /> */}
              </Grid2>
            </Grid2>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default AccountMaster;
